import { render, staticRenderFns } from "./FAQsPage.vue?vue&type=template&id=2aa7fbc6&scoped=true"
import script from "./FAQsPage.vue?vue&type=script&lang=js"
export * from "./FAQsPage.vue?vue&type=script&lang=js"
import style0 from "./FAQsPage.vue?vue&type=style&index=0&id=2aa7fbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa7fbc6",
  null
  
)

export default component.exports